import { PAIN_LEVEL_LIST } from '@/constant';
import ChangeSvg from '@/assets/icon/Union.svg';
import { bothValuesAreEmpty } from './GirthChangeItem';

import cx from './index.module.scss';

const PainLevelItem = ({ label, beforeVal, afterVal }: { label: string; beforeVal: number; afterVal: number }) => {
  return (
    <div className={cx('item')}>
      <div className={cx('label')}>{label}</div>
      <div className={cx('value')}>
        {bothValuesAreEmpty(beforeVal, afterVal) ? (
          <div className={cx('no-pain-level')}>暂无</div>
        ) : (
          <div className={cx('value-change')}>
            <div
              className={cx('pain-level', { 'no-pain-level': beforeVal === null })}
              style={{ color: PAIN_LEVEL_LIST?.find(item => item?.id === beforeVal)?.colorText }}
            >
              {beforeVal === null ? '暂无' : PAIN_LEVEL_LIST?.find(item => item?.id === beforeVal)?.desc}
            </div>
            <div className={cx('img-wrapper')}>
              <img src={ChangeSvg} />
            </div>

            <div
              className={cx('pain-level', { 'no-pain-level': afterVal === null })}
              style={{ color: PAIN_LEVEL_LIST?.find(item => item?.id === afterVal)?.colorText }}
            >
              {afterVal === null ? '暂无' : PAIN_LEVEL_LIST?.find(item => item?.id === afterVal)?.desc}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PainLevelItem;
